import {
    IconChurch,
    IconHospital,
    IconHotel,
    IconOtherHouses,
    IconSchool,
} from "../../layout/components/Icons";

export const LOCATION_TYPES = Object.freeze({
    HOTEL: "HOTEL",
    CHURCH: "CHURCH",
    SCHOOL: "SCHOOL",
    HOSPITAL: "HOSPITAL",
    OTHER: "OTHER",
} as const);

export const LOCATION_TYPES_WITH_ICONS = [
    {
        key: LOCATION_TYPES.HOTEL,
        src: IconHotel,
    },
    {
        key: LOCATION_TYPES.CHURCH,
        src: IconChurch,
    },
    {
        key: LOCATION_TYPES.SCHOOL,
        src: IconSchool,
    },
    {
        key: LOCATION_TYPES.HOSPITAL,
        src: IconHospital,
    },
    {
        key: LOCATION_TYPES.OTHER,
        src: IconOtherHouses,
    },
];

export const ADDRESS_KEYS = Object.freeze({
    STREET: "street",
    NUMBER: "number",
    ZIP_CODE: "zipCode",
    CITY: "city",
    COUNTRY: "country",
} as const);

// The object keys and the array items should be same as translation keys
export const PREDEFINED_SPACE_TEMPLATES = {
    meetingRoom: [],
    guestRoom: ["bathroom", "livingroom"],
    parkingLot: [],
    publicArea: [],
    classroom: [],
    office: [],
};

export const STEPS = Object.freeze({
    SET_COMPANY: "SET_COMPANY",
    SELECT_COMPANY: "SELECT_COMPANY",
    SET_LOCATION: "SET_LOCATION",
    SET_ADDRESS: "SET_ADDRESS",
    ADD_SPACES: "ADD_SPACES",
    ADD_SPACE_PURPOSES: "ADD_SPACE_PURPOSES",
    ASSIGN_SPACES: "ASSIGN_SPACES",
    SUMMARY: "SUMMARY",
    LOCATION_SETUP: "LOCATION_SETUP",
} as const);

export const FLOW_TYPES = Object.freeze({
    /* if you add something down here should also add the keyword to the stepper-flow */

    INITIAL: "INITIAL",
    ADD_LOCATION: "ADD_LOCATION",
    ADD_SPACES: "ADD_SPACES",
} as const);

export const STEPPER_STEPS_FLOW = Object.freeze({
    /* available steps from the STEPS-const */
    /* every step written down here should also be listed in the translation files (setUpSpaces:stepperSteps) */

    INITIAL: [
        "SET_COMPANY",
        "SET_LOCATION",
        "ADD_SPACES",
        "ADD_SPACE_PURPOSES",
        "ASSIGN_SPACES",
        "SUMMARY",
    ],
    ADD_LOCATION: [
        "SET_COMPANY",
        "SET_LOCATION",
        "ADD_SPACES",
        "ADD_SPACE_PURPOSES",
        "ASSIGN_SPACES",
        "SUMMARY",
    ],
    ADD_SPACES: [
        "ADD_SPACES",
        "ADD_SPACE_PURPOSES",
        "ASSIGN_SPACES",
        "SUMMARY",
    ],
} as const);

export const START_LINE_CSV = 7;
